// extracted by mini-css-extract-plugin
export default {"container":"e0-z","heading":"f0-z","links":"g0-z","copy":"h0-z","subCopy":"i0-z","linksLeft":"j0-z","linksCenter":"k0-z","linksRight":"l0-z","link":"m0-z","onlyLink":"n0-z"};